import { Routes, Route, Navigate } from "react-router-dom";
import WarrantyApp from "./pages/WarrantyApp";
import CustomerLogin from "./pages/CustomerLogin";
import CustomerRoute from "./routes/CustomerRoute";
import customerRoutes from "./routes/customerRoutes";
import { AuthProvider } from "./pages/context/AuthContext";
import CustomerSignup from "./pages/components/warranty/CustomerSignup";

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public */}
        <Route path="/login" element={<CustomerLogin />} />
        <Route path="/signup" element={<CustomerSignup></CustomerSignup>}></Route>
        {/* Customer App (PROTECTED) */}
        <Route
          path="/cust/*"
          element={
            <CustomerRoute>
              <WarrantyApp />
            </CustomerRoute>
          }
        >
          {customerRoutes.map((r) => (
            <Route
              key={r.path || "index"}
              path={r.path}
              element={r.element}
            />
          ))}
        </Route>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </AuthProvider>
  );
}




// import { Routes, Route, Navigate } from "react-router-dom";
// import CustomerLogin from "./pages/CustomerLogin";
// import WarrantyApp from "./pages/WarrantyApp";
// import CustomerRoute from "./routes/CustomerRoute";
// import { AuthProvider } from "./pages/context/AuthContext";


// export default function App() {
//   return (
//     <AuthProvider>
//       <Routes>
//         {/* Public */}
//         <Route path="/login" element={<CustomerLogin />} />

//         {/* Protected */}
//         <Route
//           path="/*"
//           element={
//             <CustomerRoute>
//               <WarrantyApp />
//             </CustomerRoute>
//           }
//         />

//         <Route path="*" element={<Navigate to="/login" replace />} />
//       </Routes>
//     </AuthProvider>
//   );
// }






// import logo from './logo.svg';
// import './App.css';

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <img src={logo} className="App-logo" alt="logo" />
//         <p>
//           Edit <code>src/App.js</code> and save to reload.
//         </p>
//         <a
//           className="App-link"
//           href="https://reactjs.org"
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Learn React
//         </a>
//       </header>
//     </div>
//   );
// }

// export default App;
